<template>
    <div class="log-management">
      <!-- <h2>系统日志管理</h2> -->
      
      <!-- 搜索过滤区域 -->
      <el-card class="filter-container">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="日志类型">
            <el-select v-model="searchForm.logType" placeholder="请选择日志类型" clearable>
              <el-option label="登录日志" value="login"></el-option>
              <el-option label="操作日志" value="operation"></el-option>
              <el-option label="系统日志" value="system"></el-option>
              <el-option label="错误日志" value="error"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="操作人员">
            <el-input v-model="searchForm.operator" placeholder="请输入操作人员"></el-input>
          </el-form-item>
          
          <el-form-item label="操作模块">
            <el-select v-model="searchForm.module" placeholder="请选择操作模块" clearable>
              <el-option label="用户管理" value="user"></el-option>
              <el-option label="科室管理" value="department"></el-option>
              <el-option label="权限管理" value="permission"></el-option>
              <el-option label="患者管理" value="patient"></el-option>
              <el-option label="套餐管理" value="package"></el-option>
              <el-option label="系统设置" value="settings"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="操作状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option label="成功" value="success"></el-option>
              <el-option label="失败" value="fail"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="操作时间">
            <el-date-picker
              v-model="searchForm.timeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      
      <!-- 操作按钮区域 -->
      <div class="operation-area">
        <el-button type="primary" icon="el-icon-download" @click="handleExport">导出数据</el-button>
        <el-button type="danger" icon="el-icon-delete" @click="handleClear">清空日志</el-button>
      </div>
      
      <!-- 日志列表 -->
      <el-table
        :data="filteredLogs"
        border
        stripe
        style="width: 100%; margin-top: 15px"
        v-loading="loading"
        max-height="580"
        :default-sort="{ prop: 'timestamp', order: 'descending' }"
      >
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="id" label="日志ID" width="100" align="center"></el-table-column>
        
        <el-table-column prop="type" label="日志类型" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 'login'" type="success">登录日志</el-tag>
            <el-tag v-else-if="scope.row.type === 'operation'" type="primary">操作日志</el-tag>
            <el-tag v-else-if="scope.row.type === 'system'" type="info">系统日志</el-tag>
            <el-tag v-else-if="scope.row.type === 'error'" type="danger">错误日志</el-tag>
            <el-tag v-else>{{scope.row.type}}</el-tag>
          </template>
        </el-table-column>
        
        <el-table-column prop="module" label="操作模块" width="120" align="center"></el-table-column>
        <el-table-column prop="action" label="操作类型" width="120" align="center"></el-table-column>
        
        <el-table-column prop="description" label="操作描述" min-width="250" show-overflow-tooltip></el-table-column>
        
        <el-table-column prop="operator" label="操作人员" width="120" align="center">
          <template slot-scope="scope">
            <div class="operator-info">
              <el-avatar :size="24" :src="scope.row.avatar"></el-avatar>
              <span style="margin-left: 5px">{{ scope.row.operator }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column prop="role" label="操作角色" width="120" align="center"></el-table-column>
        
        <el-table-column prop="ip" label="IP地址" width="140" align="center"></el-table-column>
        
        <el-table-column prop="timestamp" label="操作时间" width="170" sortable align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.timestamp) }}
          </template>
        </el-table-column>
        
        <el-table-column prop="status" label="操作状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'success' ? 'success' : 'danger'">
              {{ scope.row.status === 'success' ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="120" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-view" @click="handleViewDetail(scope.row)">详情</el-button>
            <el-button v-if="scope.row.type === 'error'" size="mini" type="text" icon="el-icon-warning" @click="handleViewError(scope.row)">错误</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
      
      <!-- 日志详情对话框 -->
      <el-dialog
        title="日志详情"
        :visible.sync="detailDialogVisible"
        width="700px"
      >
        <el-descriptions :column="2" border>
          <el-descriptions-item label="日志ID">{{ currentLog.id }}</el-descriptions-item>
          <el-descriptions-item label="日志类型">
            <el-tag v-if="currentLog.type === 'login'" type="success">登录日志</el-tag>
            <el-tag v-else-if="currentLog.type === 'operation'" type="primary">操作日志</el-tag>
            <el-tag v-else-if="currentLog.type === 'system'" type="info">系统日志</el-tag>
            <el-tag v-else-if="currentLog.type === 'error'" type="danger">错误日志</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="操作模块">{{ currentLog.module }}</el-descriptions-item>
          <el-descriptions-item label="操作类型">{{ currentLog.action }}</el-descriptions-item>
          <el-descriptions-item label="操作人员">{{ currentLog.operator }}</el-descriptions-item>
          <el-descriptions-item label="操作角色">{{ currentLog.role }}</el-descriptions-item>
          <el-descriptions-item label="操作状态">
            <el-tag :type="currentLog.status === 'success' ? 'success' : 'danger'">
              {{ currentLog.status === 'success' ? '成功' : '失败' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="操作时间">{{ formatDate(currentLog.timestamp) }}</el-descriptions-item>
          <el-descriptions-item label="IP地址">{{ currentLog.ip }}</el-descriptions-item>
          <el-descriptions-item label="浏览器">{{ currentLog.browser || '-' }}</el-descriptions-item>
          <el-descriptions-item label="操作描述" :span="2">{{ currentLog.description }}</el-descriptions-item>
          <el-descriptions-item label="请求URL" :span="2">{{ currentLog.requestUrl || '-' }}</el-descriptions-item>
          <el-descriptions-item label="请求方法">{{ currentLog.requestMethod || '-' }}</el-descriptions-item>
          <el-descriptions-item label="请求参数">
            <el-button size="mini" type="text" @click="showJsonDetail(currentLog.requestParams)">查看详情</el-button>
          </el-descriptions-item>
        </el-descriptions>
        
        <div v-if="currentLog.type === 'error'" class="error-stack">
          <div class="error-title">错误堆栈：</div>
          <pre class="error-content">{{ currentLog.errorStack || '无错误堆栈信息' }}</pre>
        </div>
      </el-dialog>
      
      <!-- JSON数据详情对话框 -->
      <el-dialog
        title="JSON数据详情"
        :visible.sync="jsonDialogVisible"
        width="600px"
        append-to-body
      >
        <pre class="json-content">{{ prettyJson }}</pre>
      </el-dialog>
      
      <!-- 清空日志确认对话框 -->
      <el-dialog
        title="警告"
        :visible.sync="clearDialogVisible"
        width="400px"
      >
        <div class="clear-warning">
          <i class="el-icon-warning" style="font-size: 24px; color: #E6A23C; margin-right: 10px;"></i>
          <span>确定要清空所有日志吗？此操作不可恢复！</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clearDialogVisible = false">取 消</el-button>
          <el-button type="danger" @click="confirmClear">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'log-management',
    data() {
      return {
        // 搜索表单
        searchForm: {
          logType: '',
          operator: '',
          module: '',
          status: '',
          timeRange: []
        },
        
        // 表格加载状态
        loading: false,
        
        // 分页相关
        currentPage: 1,
        pageSize: 20,
        totalCount: 0,
        
        // 对话框相关
        detailDialogVisible: false,
        jsonDialogVisible: false,
        clearDialogVisible: false,
        
        // 当前查看的日志
        currentLog: {},
        jsonData: null,
        
        // 日志列表数据（模拟数据）
        logList: [
          {
            id: 'LOG20230501001',
            type: 'login',
            module: '用户认证',
            action: '用户登录',
            description: '用户【张医生】登录系统',
            operator: '张医生',
            role: '医生',
            avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
            ip: '192.168.1.100',
            timestamp: '2023-05-01 08:30:15',
            status: 'success',
            browser: 'Chrome 112.0.0.0',
            requestUrl: '/api/auth/login',
            requestMethod: 'POST',
            requestParams: { username: 'doctor001', password: '******', rememberMe: true }
          },
          {
            id: 'LOG20230501002',
            type: 'operation',
            module: '用户管理',
            action: '新增用户',
            description: '新增用户【李护士】，角色为【护士】',
            operator: '赵管理员',
            role: '系统管理员',
            avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            ip: '192.168.1.101',
            timestamp: '2023-05-01 09:15:30',
            status: 'success',
            browser: 'Chrome 112.0.0.0',
            requestUrl: '/api/user/add',
            requestMethod: 'POST',
            requestParams: { name: '李护士', roleId: 3, departmentId: 2, phone: '13800138000', email: 'nurse@example.com' }
          },
          {
            id: 'LOG20230501003',
            type: 'operation',
            module: '患者管理',
            action: '修改患者信息',
            description: '修改患者【王小明】的基本信息',
            operator: '张医生',
            role: '医生',
            avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
            ip: '192.168.1.100',
            timestamp: '2023-05-01 10:20:45',
            status: 'success',
            browser: 'Firefox 111.0',
            requestUrl: '/api/patient/update',
            requestMethod: 'PUT',
            requestParams: { id: 12345, name: '王小明', gender: '男', age: 35, phone: '13900139000', medicalHistory: '高血压,糖尿病' }
          },
          {
            id: 'LOG20230501004',
            type: 'error',
            module: '随访管理',
            action: '新增随访计划',
            description: '尝试新增随访计划失败，数据验证错误',
            operator: '李护士',
            role: '护士',
            avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
            ip: '192.168.1.102',
            timestamp: '2023-05-01 11:05:10',
            status: 'fail',
            browser: 'Chrome 112.0.0.0',
            requestUrl: '/api/followup/plan/add',
            requestMethod: 'POST',
            requestParams: { patientId: 12345, planName: '高血压随访计划', startDate: '2023-05-05', endDate: '2023-04-05' },
            errorStack: 'Error: 结束日期必须晚于开始日期\n    at ValidateService.validateFollowupPlan (/src/services/validate.js:156:15)\n    at FollowupController.addPlan (/src/controllers/followup.js:78:30)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)'
          },
          {
            id: 'LOG20230501005',
            type: 'system',
            module: '系统维护',
            action: '系统备份',
            description: '系统数据库自动备份',
            operator: '系统',
            role: '系统',
            avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            ip: '127.0.0.1',
            timestamp: '2023-05-01 12:00:00',
            status: 'success',
            requestUrl: '/api/system/backup',
            requestMethod: 'POST',
            requestParams: { backupType: 'FULL', destination: '/backup/20230501.bak' }
          },
          {
            id: 'LOG20230501006',
            type: 'operation',
            module: '套餐管理',
            action: '修改套餐',
            description: '修改套餐【全面体检套餐】价格由1999元调整为2199元',
            operator: '赵管理员',
            role: '系统管理员',
            avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            ip: '192.168.1.101',
            timestamp: '2023-05-01 14:30:25',
            status: 'success',
            browser: 'Chrome 112.0.0.0',
            requestUrl: '/api/package/update',
            requestMethod: 'PUT',
            requestParams: { id: 1, name: '全面体检套餐', price: 2199, originalPrice: 1999 }
          },
          {
            id: 'LOG20230501007',
            type: 'login',
            module: '用户认证',
            action: '用户登出',
            description: '用户【张医生】登出系统',
            operator: '张医生',
            role: '医生',
            avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
            ip: '192.168.1.100',
            timestamp: '2023-05-01 17:45:50',
            status: 'success',
            browser: 'Chrome 112.0.0.0',
            requestUrl: '/api/auth/logout',
            requestMethod: 'POST',
            requestParams: { userId: 'doctor001' }
          },
          {
            id: 'LOG20230502001',
            type: 'login',
            module: '用户认证',
            action: '用户登录失败',
            description: '用户【unknown】尝试登录失败，用户名或密码错误',
            operator: 'unknown',
            role: '-',
            avatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
            ip: '192.168.1.120',
            timestamp: '2023-05-02 08:05:10',
            status: 'fail',
            browser: 'Chrome 112.0.0.0',
            requestUrl: '/api/auth/login',
            requestMethod: 'POST',
            requestParams: { username: 'hacker', password: '******' }
          },
          {
            id: 'LOG20230502002',
            type: 'operation',
            module: '权限管理',
            action: '角色授权',
            description: '为角色【护士长】分配新权限【查看科室统计数据】',
            operator: '赵管理员',
            role: '系统管理员',
            avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            ip: '192.168.1.101',
            timestamp: '2023-05-02 09:30:15',
            status: 'success',
            browser: 'Chrome 112.0.0.0',
            requestUrl: '/api/role/assign-permission',
            requestMethod: 'POST',
            requestParams: { roleId: 5, permissionIds: [1, 2, 3, 15, 23, 25, 30] }
          },
          {
            id: 'LOG20230502003',
            type: 'system',
            module: '系统监控',
            action: '系统警告',
            description: '系统CPU使用率超过90%，持续时间超过5分钟',
            operator: '系统',
            role: '系统',
            avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            ip: '127.0.0.1',
            timestamp: '2023-05-02 10:15:00',
            status: 'fail',
            requestParams: { cpuUsage: 92, memoryUsage: 85, duration: '5分钟' }
          },
          {
            id: 'LOG20230502004',
            type: 'error',
            module: '科室管理',
            action: '删除科室',
            description: '尝试删除科室【儿科】失败，该科室下仍有医生和患者记录',
            operator: '赵管理员',
            role: '系统管理员',
            avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            ip: '192.168.1.101',
            timestamp: '2023-05-02 11:20:30',
            status: 'fail',
            browser: 'Chrome 112.0.0.0',
            requestUrl: '/api/department/delete',
            requestMethod: 'DELETE',
            requestParams: { id: 4, name: '儿科' },
            errorStack: 'Error: 无法删除科室，该科室仍有12名医生和254条患者记录\n    at DepartmentService.deleteDepartment (/src/services/department.js:215:11)\n    at DepartmentController.deleteDepartment (/src/controllers/department.js:132:28)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)'
          },
          {
            id: 'LOG20230502005',
            type: 'operation',
            module: '患者管理',
            action: '新增患者',
            description: '新增患者【许昊然】，分配至【内科】科室',
            operator: '王前台',
            role: '前台',
            avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
            ip: '192.168.1.103',
            timestamp: '2023-05-02 14:10:45',
            status: 'success',
            browser: 'Edge 112.0.1722.58',
            requestUrl: '/api/patient/add',
            requestMethod: 'POST',
            requestParams: { name: '许昊然', gender: '男', age: 45, idCard: '410****1234', phone: '139****5678', departmentId: 1, doctorId: 5 }
          }
        ]
      }
    },
    computed: {
      // 过滤后的日志列表
      filteredLogs() {
        let results = this.logList;
        
        // 日志类型过滤
        if (this.searchForm.logType) {
          results = results.filter(log => log.type === this.searchForm.logType);
        }
        
        // 操作人员过滤
        if (this.searchForm.operator) {
          const keyword = this.searchForm.operator.toLowerCase();
          results = results.filter(log => log.operator.toLowerCase().includes(keyword));
        }
        
        // 模块过滤
        if (this.searchForm.module) {
          results = results.filter(log => {
            // 在实际应用中，这里应该根据模块代码查找对应的模块，这里简化处理
            if (this.searchForm.module === 'user' && log.module.includes('用户')) return true;
            if (this.searchForm.module === 'department' && log.module.includes('科室')) return true;
            if (this.searchForm.module === 'permission' && log.module.includes('权限')) return true;
            if (this.searchForm.module === 'patient' && log.module.includes('患者')) return true;
            if (this.searchForm.module === 'package' && log.module.includes('套餐')) return true;
            if (this.searchForm.module === 'settings' && log.module.includes('系统')) return true;
            return false;
          });
        }
        
        // 状态过滤
        if (this.searchForm.status) {
          results = results.filter(log => log.status === this.searchForm.status);
        }
        
        // 时间范围过滤
        if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
          const startDate = new Date(this.searchForm.timeRange[0]);
          const endDate = new Date(this.searchForm.timeRange[1]);
          endDate.setHours(23, 59, 59, 999); // 设置结束日期为当天的23:59:59.999
          
          results = results.filter(log => {
            const logDate = new Date(log.timestamp);
            return logDate >= startDate && logDate <= endDate;
          });
        }
        
        // 更新总数
        this.totalCount = results.length;
        
        // 分页处理
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        return results.slice(startIndex, endIndex);
      },
      
      // JSON格式化显示
      prettyJson() {
        return this.jsonData ? JSON.stringify(this.jsonData, null, 2) : '{}';
      }
    },
    created() {
      this.totalCount = this.logList.length;
    },
    methods: {
      // 搜索处理
      handleSearch() {
        this.currentPage = 1;
        // 实际应用中这里可能需要调用API
      },
      
      // 重置搜索条件
      resetSearch() {
        this.$refs.searchForm.resetFields();
        this.currentPage = 1;
      },
      
      // 分页相关方法
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      
      // 查看日志详情
      handleViewDetail(row) {
        this.currentLog = row;
        this.detailDialogVisible = true;
      },
      
      // 查看错误详情
      handleViewError(row) {
        this.currentLog = row;
        this.detailDialogVisible = true;
      },
      
      // 显示JSON详情
      showJsonDetail(json) {
        this.jsonData = json;
        this.jsonDialogVisible = true;
      },
      
      // 导出数据
      handleExport() {
        this.$message({
          message: '日志数据导出成功',
          type: 'success'
        });
      },
      
      // 清空日志
      handleClear() {
        this.clearDialogVisible = true;
      },
      
      // 确认清空日志
      confirmClear() {
        this.loading = true;
        
        // 模拟清空操作
        setTimeout(() => {
          this.logList = [];
          this.totalCount = 0;
          this.loading = false;
          this.clearDialogVisible = false;
          
          this.$message({
            message: '日志已清空',
            type: 'success'
          });
        }, 1000);
      },
      
      // 时间格式化
      formatDate(dateStr) {
        return dateStr; // 假数据已格式化，实际应用中可能需要格式化处理
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .log-management {
    padding: 20px;
    
    h2 {
      margin-bottom: 20px;
      font-weight: 500;
      color: #303133;
    }
    
    .filter-container {
      margin-bottom: 20px;
      
      .el-form {
        display: flex;
        flex-wrap: wrap;
      }
    }
    
    .operation-area {
      margin-bottom: 15px;
      display: flex;
      justify-content: flex-end;
    }
    
    .pagination-container {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
    
    .operator-info {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .error-stack {
      margin-top: 20px;
      padding: 10px;
      background-color: #f8f8f8;
      border-radius: 4px;
      
      .error-title {
        font-weight: bold;
        margin-bottom: 5px;
        color: #f56c6c;
      }
      
      .error-content {
        margin: 0;
        font-family: monospace;
        font-size: 14px;
        overflow-x: auto;
        color: #f56c6c;
      }
    }
    
    .json-content {
      margin: 0;
      padding: 10px;
      background-color: #f8f8f8;
      border-radius: 4px;
      font-family: monospace;
      font-size: 14px;
      overflow-x: auto;
    }
    
    .clear-warning {
      display: flex;
      align-items: center;
      color: #606266;
    }
  }
  </style>